module.exports = {
	"changes": {
		"breaks": {
			"major": 2,
			"minor": 3,
			"patch": 3,
			"unchanged": 3
		},
		"smooths": {
			"major": 0,
			"minor": 1,
			"patch": 2,
			"unchanged": 3
		}
	},
	"default": {
		"breaks": 2,
		"smooths": 1
	}
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/defaultConfig.json
 ** module id = 46
 ** module chunks = 0
 **/